import { OdataManager } from '@/api/odata/odata-manager';
import { RegisterReview } from '@/api/model/interfaces';

export default class RegisterReviewOdata extends OdataManager<RegisterReview> {}
